import { useQueryClient } from '@tanstack/react-query';
import { UserKeys } from '../../api/users-api';
import { UserSettings } from '../../../types';
import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';

export const useAnalytics = () => {
  const queryClient = useQueryClient();
  const posthog = usePostHog();

  const userSettings = queryClient.getQueryData<UserSettings>([
    UserKeys.UserSettings,
  ]);

  const customerId = userSettings?.subscription?.customerId;
  const gpanelTier = userSettings?.subscription?.gPanelPackage;
  const gpanelUserCount = userSettings?.subscription?.gPanelUserCount;
  const isGabCustomer = userSettings?.subscription?.gabCustomer;

  const createEvent = useCallback(
    (event: string, additionalData?: object) => {
      const data = {
        customerId: customerId,
        gpanelTier: gpanelTier,
        gpanelUserCount: gpanelUserCount,
        isGabCustomer: isGabCustomer,
      };

      posthog.capture(event, {
        ...additionalData,
        $set: data,
      });
    },
    [customerId, gpanelTier, gpanelUserCount, isGabCustomer, posthog]
  );

  const createPageViewEvent = useCallback(() => {
    const data = {
      customerId: customerId,
      gpanelTier: gpanelTier,
      gpanelUserCount: gpanelUserCount,
      isGabCustomer: isGabCustomer,
    };

    posthog.capture('$pageview', {
      $set: data,
    });
  }, [customerId, gpanelTier, gpanelUserCount, isGabCustomer, posthog]);

  return { createEvent, createPageViewEvent };
};
